<template>
    <modal
        name="promt-modal"
        height="auto"
        @before-open="beforeOpen"
        :max-width="470"
        width="80%"
        :click-to-close="false"
        :scrollable="true"
    >
        <div class="modalBox promtModal">
            <div class="contentBox p-3">
                <div class="d-flex justify-content-end">
                    <img @click="doDeny" class="closeIcon" :src="getStaticImage('icons/menu/closeIcon.png')"/>
                </div>
                
                <h5 class="colorBlack" v-if="title">{{title}}</h5>
                <div v-if="content" v-html="content"></div>
            </div>
            <div class="buttons d-flex regText muliBold">
                <div @click="doSuccess">{{buttonConfirm}}</div>
                <div @click="doDeny">{{buttonCancel}}</div>
            </div>
        </div>
    </modal>
</template>

<script>
    export default {
        name: "Promt",
        data() {
            return {
                title: "",
                content: "",
                buttonConfirm: "",
                buttonCancel: "",
                deny: null,
                success: null
            }
        },
        methods: {
            beforeOpen(event) {
                //console.log(event.params.title);
                this.title = event.params.title;
                this.content = event.params.content;
                this.success = event.params.success ? event.params.success : () =>{};
                this.deny = event.params.deny ? event.params.deny : () =>{};
                this.buttonConfirm = event.params.buttonConfirm ? event.params.buttonConfirm : "Confirm";
                this.buttonCancel = event.params.buttonCancel ? event.params.buttonCancel : "Cancel";
            },
            doSuccess(){
                this.success();
                this.$modal.hide('promt-modal')
            },
            doDeny(){
                this.deny();
                this.$modal.hide('promt-modal');
            }
        }
    }
</script>
